/*
 * @Description: 国际化语言配置
 * @Author: 刘宝顺
 * @Date: 2024-02-01 14:13:38
 * @LastEditTime: 2024-02-04 14:47:48
 * @LastEditors: 刘宝顺
 */

import i18next from 'i18next';

import { initReactI18next, useTranslation } from 'react-i18next';

import resources from '../locales/resources';

import { LANGUAGE_TYPES } from '@/constants/common';
import EStorageConst from '@/constants/storage';

import type { ModuleType } from 'i18next';

const { languageKey } = EStorageConst;
export type TLanguageCodeType = 'en-US' | 'locale' | 'zh-CN';

/**
 * @desc 获取当前选择语言
 * @returns 'en-US' | 'locale' | 'zh-CN' | undefined
 */

export const getLanguage = (): TLanguageCodeType | undefined => {
    const language = localStorage.getItem(languageKey) as TLanguageCodeType | undefined;
    return language;
};

/**
 * 获取当前系统语言
 * @returns
 */
export const getSystemLanguage = (): string => {
    const locales = navigator.language.toLowerCase();
    const lang = LANGUAGE_TYPES.find((v) => v.value === locales);
    return lang ? lang.code : 'en';
};

const languageDetector = {
    type: 'languageDetector' as ModuleType,
    async: true,
    detect(callback: (lang: string) => void) {
        // 获取上次选择的语言
        const lang = localStorage.getItem(EStorageConst.languageKey);
        // 如果是跟随本地，则获取系统语言
        if (!lang || lang === 'locale') {
            callback(getSystemLanguage());
        } else {
            callback(lang);
        }
    },
};

// 初始化i18next配置

void i18next
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        compatibilityJSON: 'v3',
        fallbackLng: 'en-US', // 切换语言失败时的使用的语言
        // 资源文件
        resources,
        lng: 'en-US', // 默认语言
        react: {
            useSuspense: false,
        },
    });

/**
 * 切换语言
 * @param lang
 */
export const changeLanguage = async (lang?: TLanguageCodeType): Promise<void> => {
    // 切换语言
    await i18next.changeLanguage(lang === 'locale' ? getSystemLanguage() : lang, (res) => {
        // console.log('切换->', JSON.stringify(res));
    });
    // 持久化当前选择
    lang && localStorage.setItem(EStorageConst.languageKey, lang);
};
/**
 * @description: 国际化翻译文字内容，加入TS类型限制
 * @author: 刘宝顺
 * @param {*} t
 * @param {unknown} opts
 * @return {*}
 */
export function useMyTranslation(): ITranslation {
    const { t } = useTranslation() as ITranslation;
    return { t };
}

export const useI18n = (): ITranslation => {
    return useTranslation() as ITranslation;
};

export default i18next;
